import { VideoRecordingButtonPropTypes } from './VideoRecordingButtonTypes';
import './VideoRecordingButtonStyles.scss';

export const VideoRecordingButton = (props: VideoRecordingButtonPropTypes) => {
   const { active, disabled, ...restProps } = props;

   return (
      <div
         {...restProps}
         className={`video-button-outer-container ${active ? 'active' : 'in-active'}${disabled ? ' disabled': ''}`}
      />
   );
};
